import { Manager, Socket } from 'socket.io-client';

const URL = `${
  globalThis.location.port !== '' && globalThis.location.port !== '443'
    ? 'ws'
    : 'wss'
}://${globalThis.location.hostname}${
  globalThis.location.port === '443' ? '' : `:${globalThis.location.port}`
}`;

const DATA_FILE_SOCKET_ROOT = '/api/data-ingestion/socket-io';
const DATA_FILE_SOCKET_NAMESPACE = `${DATA_FILE_SOCKET_ROOT}/tabledatafile/`;

type CleanupCallback = (socket: Socket) => void;

type SocketEntry = {
  socket: Socket;
  cleanupCallbacks: Set<CleanupCallback>;
};

const sockets = new Map<string, SocketEntry>();

const handleBeforeUnload = () => {
  sockets.forEach((entry) => {
    entry.cleanupCallbacks.forEach((callback) => callback(entry.socket));
  });
};

globalThis.addEventListener('beforeunload', handleBeforeUnload);

export const dataFileSocketManager = {
  get(
    authToken: string,
    dataFileId: string,
    onCleanup?: CleanupCallback,
  ): Socket {
    let entry = sockets.get(dataFileId);

    if (!entry) {
      const socket = new Manager(URL, {
        path: DATA_FILE_SOCKET_ROOT,
        transports: ['websocket'],
        query: {
          authorization: encodeURIComponent(authToken),
        },
      }).socket(DATA_FILE_SOCKET_NAMESPACE);

      const onConnect = () => {
        socket.emit('subscribe_updates', {
          table_data_file_id: dataFileId,
        });
      };

      socket.connect();
      socket.on('connect', onConnect);

      entry = {
        socket,
        cleanupCallbacks: new Set(),
      };

      sockets.set(dataFileId, entry);
    }

    if (onCleanup) {
      entry.cleanupCallbacks.add(onCleanup);
    }

    return entry.socket;
  },

  release(dataFileId: string): void {
    const entry = sockets.get(dataFileId);

    if (!entry) {
      return;
    }

    entry.cleanupCallbacks.forEach((callback) => callback(entry.socket));
    entry.socket.off();
    entry.socket.disconnect();
    sockets.delete(dataFileId);
  },
};
